import { Container, Flex, Text } from "@chakra-ui/react";
import { TripBox } from "components";
import { TRIPS_DEMO } from "data";
import { useHistory } from "react-router-dom";
import { routes } from "utils";

type IPreviousTrips = {
    trips: string[];
}

const PreviousTrips = ({trips}: IPreviousTrips) => {
    const history = useHistory();

    return (
      <Container>
        <Text fontWeight={700} fontSize='26px'>{`Previous Trips (${trips.length})`}</Text>
        {TRIPS_DEMO.map((data) => (
             <Flex cursor='pointer'  onClick={() => history.push(routes.PROFILE.TRIP_ITINERARY.replace(':id', data.id.toString()))}>
                <TripBox data={data} />
            </Flex>
        ))}
      </Container>
    );
  };
  
  export { PreviousTrips };
  